import React from 'react'

import { PaymentMethod as PaymentMethodEnum } from '@/enums/payments'

export type selectPaymentMethodFunc = (type: PaymentMethodEnum) => void

type PaymentMethodProps = {
  paymentType: PaymentMethodEnum
  isSelected: boolean
  onClick: selectPaymentMethodFunc
} & React.PropsWithChildren

const typeToClassName = {
  [PaymentMethodEnum.CARD]: 'credit-card',
  [PaymentMethodEnum.PAYPAL]: 'paypal',
  [PaymentMethodEnum.APPLE_PAY]: 'apple-pay',
  [PaymentMethodEnum.GOOGLE_PAY]: 'google-pay',
}

export const PaymentMethod = ({
  paymentType,
  isSelected,
  onClick,
  children,
}: PaymentMethodProps) => {
  let className = 'method ' + typeToClassName[paymentType] || ''
  if (isSelected) {
    className += ' selected'
  }
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    <div className={className} onClick={() => onClick(paymentType)}>
      {children}
    </div>
  )
}
